import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientsubscriptionApiController from "services/clientsubscription.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
import { beginClientHistoryRequest, ownsClientHistoryRequest } from "./clientHistoryOwnership";

export const ClientSubscriptionListViewApi = createAsyncThunk("clientsubscription/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientsubscriptionApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SubscriptionCancellationApi = createAsyncThunk("subscription/cancel", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await clientsubscriptionApiController
      .cancelsubscription(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "cancelsubscription"))
      .catch((error) => HandleError(thunkAPI, error, "cancelsubscription"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

const initialState = {
  listClientId: null,
  listQueryKey: null,
  listRequestId: null,
  isListView: [],
  isListViewError: "",
  isSubScriptionCancel: "",
  isApiStatus: {
    ClientSubscriptionListViewApi: "",
    SubscriptionCancellationApi: "",
  },
};

const clientsubscriptionSlice = createSlice({
  name: "clientsubscription",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientSubscriptionListViewApi.pending, (state, action) => {
        beginClientHistoryRequest(state, action);
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "loading" };
        state.isListViewError = "";
      })
      .addCase(ClientSubscriptionListViewApi.fulfilled, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        const previous = state.isListView;
        const isNextPage = previous && previous.current_page < action.payload.current_page;
        state.isListView = isNextPage && Array.isArray(previous.data) && Array.isArray(action.payload.data)
          ? { ...action.payload, data: [...previous.data, ...action.payload.data] }
          : action.payload;
        state.isListViewError = "";
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "succeeded" };
      })
      .addCase(ClientSubscriptionListViewApi.rejected, (state, action) => {
        if (!ownsClientHistoryRequest(state, action)) return;
        state.isApiStatus = { ...state.isApiStatus, ClientSubscriptionListViewApi: "failed" };
        state.isListViewError = contentErrorMessage(action, "Unable to load subscriptions.");
      })
      .addCase(SubscriptionCancellationApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "loading" };
      })
      .addCase(SubscriptionCancellationApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "succeeded" };
        state.isSubScriptionCancel = action.payload;
      })
      .addCase(SubscriptionCancellationApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, SubscriptionCancellationApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset } = clientsubscriptionSlice.actions;
export default clientsubscriptionSlice.reducer;
